// Description: Render an input for creating email
// Updated: 02/09/2025
// Author: Simon Franklin

// React
import React, { useEffect, useRef, useState } from "react";

// Material UI Components
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionSummary, AccordionDetails, Grid, Typography, MenuItem, FormControl, TextField } from "@mui/material";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { WhatsAppImproveText } from "../../api/n8n/ai/WhatsAppImproveText";
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import themeColors from "../ThemeColors/ThemeColors";
import { notify } from "../../utils/utils";

// Render the Component
const TemplateInput = ({ value, handleChange, type, title, variablesOfTemplate, header = false }) => {
    // State variables
    const [isVisible, setIsVisible] = useState(false);
    const [expanded, setExpanded] = useState(false);
    const [loadingText, setLoadingText] = useState(false);
    const [errorAI, setErrorAI] = useState(false);
    const [hover, setHover] = useState(false);
    const [focused, setFocused] = useState(false);

    const limit = type === 'whatsappapi' ? header === true ? 60 : 550 : 'whatsappweb' ? 1000 : type === 'sms' ? 160 : type === 'email' ? 2000 : null

    // Function to toggle the visibility of the variables
    const toggleAccordionVisibility = () => {
        setIsVisible(!isVisible);
    };

    // Function to handle the change of the accordion
    const handleChangeAccordion = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    const closeAccordion = () => {
        setExpanded(false);
    };

    const inputRef = useRef(null);
    const [cursorPosition, setCursorPosition] = useState(null);

    const handleFocus = () => {
        const input = inputRef.current;
        if (input) {
            setCursorPosition(input.selectionStart);
        }

        setFocused(true);
        setHover(false);
    };

    const addVariableInTemporaryMessage = (variable) => {
        const position = cursorPosition ?? value.length;
        const newText =
            value.slice(0, position) + ` {{${variable}}}` + value.slice(position);

        handleChange(newText);

        setTimeout(() => {
            const input = inputRef.current;
            if (input) {
                const newCursorPosition = position + ` {{${variable}}}`.length;
                input.focus();
                input.setSelectionRange(newCursorPosition, newCursorPosition);
            }
        }, 0);
    };

    const improveTextWithAI = async () => {
        try {

            setLoadingText(true);
            setErrorAI(false);

            const data = {
                message: value
            };

            const response = await WhatsAppImproveText(data);
            console.log("Resposta da API:", response);

            if (response && response.data && response.data.length > 0) {
                const newMessage = response.data[0].message;
                const formattedMessage = newMessage.replace(/\\n/g, '\n').replace(/\\'/g, "'").replace(/\\"/g, '"').replace(/\\\\/g, '\\');
                handleChange(formattedMessage);
            } else {
                setErrorAI(true);
                return;
            }
        } catch (error) {
            console.error("Erro ao melhorar o texto:", error);
            setErrorAI(true);
        }
        finally {
            setLoadingText(false);
        }
    };

    return (

        <>
            {
                header === false && (
                    <>
                        <Grid item xs={6}>
                            <Typography style={{ color: themeColors.gray40, fontSize: '20px' }}>Mensagem</Typography>
                        </Grid>
                        <Grid item xs={6} style={{ position: 'relative' }}>
                            <FormControl fullWidth>
                                <Typography onClick={toggleAccordionVisibility} style={{
                                    color: themeColors.purple500,
                                    marginRight: '5px',
                                    marginTop: '2px',
                                    fontFamily: 'Satoshi-Medium',
                                    fontSize: '18px',
                                    display: 'flex',
                                    justifyContent: 'flex-end',
                                    cursor: 'pointer'
                                }}>
                                    {isVisible ? "Esconder Variáveis" : "+ Adicionar Variáveis"}
                                </Typography>
                                {isVisible && (
                                    <div style={{
                                        position: 'absolute',
                                        right: 0,
                                        top: '100%',
                                        width: 'auto',
                                        backgroundColor: themeColors.purple200,
                                        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                        overflow: 'hidden',
                                        zIndex: 1,
                                        borderRadius: '12px'
                                    }}>
                                        {Object.entries(variablesOfTemplate).map(([category, values]) => (
                                            <Accordion key={category} expanded={expanded === category} onChange={handleChangeAccordion(category)} style={{ background: themeColors.purple200, border: 'none !important' }}>
                                                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                                    <Typography>{category}</Typography>
                                                </AccordionSummary>
                                                <AccordionDetails style={{ border: 'none !important', padding: 0 }}>
                                                    {values.length > 0 ? (
                                                        values.map((value) => (
                                                            <MenuItem key={value} onClick={() => {
                                                                addVariableInTemporaryMessage(value);
                                                                toggleAccordionVisibility();
                                                                closeAccordion();
                                                            }} style={{ color: themeColors.purple950 }}>
                                                                {value}
                                                            </MenuItem>
                                                        ))
                                                    ) : (
                                                        <Typography>Adicionar variáveis</Typography>
                                                    )}
                                                </AccordionDetails>
                                            </Accordion>
                                        ))}
                                    </div>
                                )}
                            </FormControl>
                        </Grid>
                    </>
                )
            }

            <Grid item xs={12}>
                <FormControl fullWidth style={{ position: 'relative' }}>
                    {header === false ? (
                        <textarea
                            className="template_input"
                            onMouseEnter={() => {
                                if (focused === false) {
                                    setHover(true);
                                }
                            }}
                            onMouseLeave={() => setHover(false)}
                            ref={inputRef}
                            value={value}
                            placeholder="Seu Texto"
                            rows={9}
                            style={{
                                background: "white",
                                color: "black",
                                borderRadius: "12px",
                                margin: 0,
                                border: `1px solid ${hover === true ? themeColors.purple500 : themeColors.gray20}`,
                                color: themeColors.gray40,
                                height: String(type).includes("whatsapp")
                                    ? header === true
                                        ? "auto"
                                        : "309px"
                                    : "401px",
                                width: "100%",
                                padding: "14px",
                                outline: "none",
                                whiteSpace: "pre-wrap",
                                overflowY: "auto",
                                resize: "none",
                                fontFamily: "inherit",
                                fontSize: "16px",
                                outline: focused === true ? "3px solid hsla(260, 97%, 62%, 0.5)" : "none",
                                color: "#000"
                            }}
                            onClick={handleFocus}
                            onKeyUp={handleFocus}
                            onFocus={handleFocus}
                            onBlur={() => setFocused(false)}
                            onChange={(e) => {
                                const value = e.target.value;
                                const length = value.length;

                                if (
                                    (type.includes("whatsapp") && length > (header === true ? 60 : 550)) ||
                                    (type === "sms" && length > 160) ||
                                    (type === "email" && length > 2000)
                                ) {
                                    notify(
                                        "Alert",
                                        "Você atingiu o limite de caracteres por mensagem",
                                        true
                                    );
                                    return;
                                }

                                handleChange(value);
                                handleFocus();
                            }}
                        />
                    ) : (
                        <input
                            className="template_input"
                            onMouseEnter={() => {
                                if (focused === false) {
                                    setHover(true)
                                }
                            }}
                            onMouseLeave={() => setHover(false)}
                            ref={inputRef}
                            type="text"
                            value={value}
                            placeholder="Seu Texto"
                            style={{
                                background: "white",
                                color: "black",
                                borderRadius: "12px",
                                margin: 0,
                                border: `1px solid ${hover === true ? themeColors.purple500 : themeColors.gray20}`,
                                color: themeColors.gray40,
                                width: "100%",
                                padding: "14px",
                                outline: "none",
                                fontFamily: "inherit",
                                fontSize: "16px",
                                outline: focused === true ? "3px solid hsla(260, 97%, 62%, 0.5)" : "none",
                                color: "#000"
                            }}
                            onClick={handleFocus}
                            onKeyUp={handleFocus}
                            onFocus={handleFocus}
                            onBlur={() => setFocused(false)}
                            onChange={(e) => {
                                const value = e.target.value;
                                const length = value.length;

                                if (
                                    (type.includes("whatsapp") && length > (header === true ? 60 : 550)) ||
                                    (type === "sms" && length > 160) ||
                                    (type === "email" && length > 2000)
                                ) {
                                    notify(
                                        "Alert",
                                        "Você atingiu o limite de caracteres por mensagem",
                                        true
                                    );
                                    return;
                                }

                                handleChange(value);
                                handleFocus();
                            }}
                        />
                    )}
                    <div style={{ fontSize: '14px', display: type.includes('whatsapp') === false && type !== 'sms' ? null : 'flex', zIndex: 100, width: 'auto', justifyContent: 'end', paddingTop: '6px' }}>
                        {value.length} de {limit}
                    </div>
                </FormControl>
            </Grid>
            {
                header === false && (
                    <Grid item xs={12} mt={2}>
                        <Button
                            variant="contained"
                            onClick={improveTextWithAI}
                            fullWidth
                            sx={{
                                background: errorAI ? themeColors.red01 : themeColors.purple200,
                                color: themeColors.gray30,
                                fontSize: '14px',
                                padding: '13px',
                                borderRadius: '4px',
                                textTransform: "none",
                                '&:hover': {
                                    backgroundColor: errorAI ? themeColors.red01 : themeColors.purple300,
                                    "& svg": {
                                        color: errorAI ? themeColors.red03 : themeColors.purple950,
                                    },
                                },
                                '@keyframes wiggleTogether': {
                                    '0%': { transform: 'translateX(0)' },
                                    '50%': { transform: 'translateX(4px)' },
                                    '100%': { transform: 'translateX(0)' },
                                }
                            }}
                            disabled={loadingText}
                        >
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px',
                                    animation: 'wiggleTogether 2.5s ease-in-out infinite',
                                    color: errorAI ? themeColors.red03 : themeColors.purple800,
                                    '&:hover': {
                                        color: errorAI ? themeColors.red03 : themeColors.purple950,
                                    },
                                }}
                            >
                                <AutoAwesomeIcon style={{ color: errorAI ? themeColors.red03 : themeColors.purple800 }} />
                                {!loadingText && !errorAI ? (
                                    <span>Clique aqui para melhorar seu texto com IA</span>
                                ) : loadingText ? (
                                    <span>Aguarde, estamos melhorando seu texto...</span>
                                ) : (
                                    <span style={{ color: themeColors.red02 }}>Ocorreu um erro. Clique para tentar novamente</span>
                                )}
                            </Box>
                        </Button>
                    </Grid>
                )
            }
        </>
    );
};

export default TemplateInput;